import { Message } from "element-ui";
import ErrorImage from "@/assets/images/errImg.jpg";

/**
 * 表头文字说明 - 可选必填
 * @param {*} h 渲染函数
 * @param {*} label 表头文字
 * @param {*} explanation 说明
 * @param {*} isRequest 是否增加必填星号
 * @returns
 */
function tableHeaderExplanation(h, label, explanation, isRequest = false) {
  return h(
    "div",
    {
      style: {
        position: "relative",
        paddingLeft: isRequest ? "4px" : "",
      },
    },
    [
      isRequest
        ? h(
            "span",
            {
              style: {
                position: "absolute",
                top: "0",
                left: "-4px",
                color: "#F56C6C",
              },
            },
            "*"
          )
        : "",
      h("span", label),
      h(
        "el-popover",
        {
          attrs: {
            placement: "top",
            trigger: "hover",
            content: explanation,
          },
          style: {
            marginLeft: "4px",
          },
        },
        [
          h("i", {
            slot: "reference",
            class: "el-icon-warning-outline",
          }),
        ]
      ),
    ]
  );
}

/**
 * 表头必填字段
 * @param {*} h 渲染函数
 * @param {*} label 表头文字
 * @returns
 */
function tableHeaderRequest(h, label) {
  return h(
    "div",
    {
      style: {
        position: "relative",
        paddingLeft: "4px",
      },
    },
    [
      h(
        "span",
        {
          style: {
            position: "absolute",
            top: "0",
            left: "-4px",
            color: "#F56C6C",
          },
        },
        "*"
      ),
      h("span", {}, label),
    ]
  );
}

/**
 * 数据描述
 * @param {*} h 渲染函数
 * @param {*} label 表头文字
 * @param {*} explanation 说明
 */
function dataDescription(h, label, explanation) {
  return h("div", {}, [
    h("span", label),
    h(
      "el-popover",
      {
        attrs: {
          placement: "bottom",
          trigger: "hover",
          content: explanation,
        },
        style: {
          marginLeft: "4px",
        },
      },
      [
        h("i", {
          slot: "reference",
          class: "el-icon-warning-outline",
        }),
      ]
    ),
  ]);
}

/**
 * 字段说明 - 数组
 * @param {*} h 渲染函数
 * @param {*} label 表头文字
 * @param {*} explanationList 说明
 * @param {*} isRequest 是否增加必填星号
 */
function tableHeaderMultiExplanation(
  h,
  label,
  explanationList,
  isRequest = false
) {
  let result = [];
  explanationList.map((item) => {
    result.push(h("div", item));
  });
  return h(
    "div",
    {
      style: {
        position: "relative",
        paddingLeft: isRequest ? "4px" : "",
      },
    },
    [
      isRequest
        ? h(
            "span",
            {
              style: {
                position: "absolute",
                top: "0",
                left: "-4px",
                color: "#F56C6C",
              },
            },
            "*"
          )
        : "",
      h("span", label),
      h(
        "el-popover",
        {
          attrs: {
            placement: "bottom",
            trigger: "hover",
          },
          style: {
            marginLeft: "4px",
          },
        },
        [
          ...result,
          h("i", {
            slot: "reference",
            class: "el-icon-warning-outline",
          }),
        ]
      ),
    ]
  );
}

/**
 * 悬浮 - 数组
 * @param {*} h 渲染函数
 * @param {*} explanationList 文本、悬浮框显示内容
 * @param {*} value 非必填，文本显示内容
 * @param {*} valueClass 非必填，文本显示样式
 * @param {*} width 非必填，悬浮框宽度
 * @returns
 */
function fieldPopover(h, explanationList, value, valueClass, width) {
  let result = [];
  explanationList.map((item) => {
    result.push(h("div", item));
  });
  if (value) {
    return h(
      "el-popover",
      {
        attrs: { placement: "top", trigger: "hover", width: width || 500 },
      },
      [
        ...result,
        h(
          valueClass ? "span" : "div",
          {
            class: valueClass ? valueClass : "hideOverflow",
            slot: "reference",
          },
          value || "-"
        ),
      ]
    );
  }
  return explanationList.length
    ? h("div", {}, [
        h(
          "el-popover",
          {
            attrs: {
              placement: "bottom",
              trigger: "hover",
            },
            style: {
              marginLeft: "4px",
            },
          },
          [
            ...result,
            h(
              "span",
              {
                slot: "reference",
              },
              explanationList[0] + (explanationList.length > 1 ? "..." : "")
            ),
          ]
        ),
      ])
    : h("div", "-");
}

/**
 * 字段拷贝
 * @param {*} h 渲染函数
 * @param {*} value 文本
 * @param {*} isLink 是否是链接
 * @param {*} linkFunc 链接回调
 * @param {*} iconClass 图标
 * @returns
 */
function fieldCopy(h, value, isLink = false, linkFunc, iconClass) {
  return h(
    "p",
    {
      class: "iconP",
      slot: "reference",
      attrs: { slot: "reference" },
    },
    [
      isLink
        ? h(
            "span",
            {
              style: "color:#01AAED;cursor: pointer;text-decoration: none;",
              on: {
                click: () => {
                  linkFunc();
                },
              },
            },
            iconClass
              ? [
                  h("span", value || "-"),
                  h("i", {
                    class: iconClass,
                    style: {
                      color: "#595959",
                      marginLeft: "8px",
                    },
                  }),
                ]
              : value || "-"
          )
        : h("span", value || "-"),
      h("i", {
        class: "el-icon-document-copy pointer icon green-Cd0100",
        style: { marginLeft: "4px" },
        on: {
          click: () => {
            copy(value);
          },
        },
      }),
    ]
  );
}

// 复制文本
function copy(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    document.execCommand("copy");
    Message.success("已成功复制到剪贴板");
  } catch (err) {
    Message.error("无法复制到剪贴板");
  }
  document.body.removeChild(textArea);
}

/**
 * 字段悬浮、拷贝
 * @param {*} h 渲染函数
 * @param {*} value 文本
 * @param {*} copyText 非必填，拷贝文本；不传则value作为拷贝文本
 * @param {*} isCopy 非必填，是否可拷贝；不传则默认可拷贝
 * @returns
 */
function fieldPopoverAndCopy(h, value, copyText, isCopy = true) {
  return h(
    "el-popover",
    {
      attrs: { placement: "top", trigger: "hover", width: 400 },
    },
    isCopy
      ? [
          h("p", { class: "stringWrap" }, value || "-"),

          h(
            "div",
            {
              class: "iconP",
              slot: "reference",
              attrs: { slot: "reference" },
              style: {
                display: "flex",
                gap: "4px",
                alignItems: "center",
              },
            },
            [
              h(
                "div",
                {
                  class: "hideOverflow",
                  style: { maxWidth: "80%" },
                },
                value || "-"
              ),
              h("i", {
                class: "el-icon-document-copy pointer icon green-Cd0100",
                on: {
                  click: () => {
                    copy(copyText || value);
                  },
                },
              }),
            ]
          ),
        ]
      : [
          h("p", `${value || "-"}`),
          h(
            "div",
            {
              class: "hideOverflow",
              slot: "reference",
            },
            value || "-"
          ),
        ]
  );
}

/**
 * 字段悬浮、编辑
 * @param {*} h 渲染函数
 * @param {*} value 文本
 * @param {*} fn 编辑回调
 * @returns
 */
function fieldPopoverAndEdit(h, value, fn) {
  return h(
    "el-popover",
    {
      attrs: { placement: "top", trigger: "hover", width: 400 },
    },
    [
      h("p", { class: "stringWrap" }, value || "-"),
      h(
        "div",
        {
          class: "iconP",
          slot: "reference",
          attrs: { slot: "reference" },
          style: {
            display: "flex",
            gap: "4px",
            alignItems: "center",
          },
        },
        [
          h(
            "div",
            {
              class: "hideOverflow",
              style: { maxWidth: "80%" },
            },
            value || "-"
          ),
          h("i", {
            class: "el-icon-edit pointer green-Cd0100",
            on: {
              click: () => {
                fn();
              },
            },
          }),
        ]
      ),
    ]
  );
}

/**
 * 表格图片
 * @param {*} h 渲染函数
 * @param {*} url 图片地址
 * @param {*} width 图片宽度
 * @returns
 */
function tableImage(h, url, width) {
  return h(
    "el-popover",
    {
      attrs: {
        placement: "top-start",
        trigger: "hover",
        width: "300",
      },
    },
    [
      h("el-image", {
        props: {
          src: url,
          fit: url,
        },
        style: {
          width: "300px",
          height: "300px",
        },
      }),
      h(
        "el-image",
        {
          slot: "reference",
          style: {
            width: width || "40px",
            height: width || "40px",
          },
          props: {
            src: url,
            fit: url,
            previewSrcList: [url],
          },
        },
        [
          h("div", { slot: "error", class: "image-slot" }, [
            h("img", {
              style: {
                width: "100%",
              },
              attrs: {
                src: ErrorImage,
              },
            }),
          ]),
        ]
      ),
    ]
  );
}
export {
  fieldPopoverAndEdit,
  tableHeaderExplanation,
  tableHeaderRequest,
  dataDescription,
  tableHeaderMultiExplanation,
  fieldPopover,
  fieldPopoverAndCopy,
  tableImage,
  fieldCopy,
};
